import { render, staticRenderFns } from "./BtnComunicarConclusao.vue?vue&type=template&id=21ef06fc"
import script from "./BtnComunicarConclusao.vue?vue&type=script&lang=js"
export * from "./BtnComunicarConclusao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports